import React, { useState, useEffect } from "react";
import {
  BaseUrl,
  VoiceDomainName,
  VoiceDomainNamePure,
} from "../../Container/BaseUrl/BaseUrl";
import {
  Button,
  Pagination,
  Typography,
  Stack,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  Box,
  IconButton,
  Drawer,
  ButtonGroup,
  Grid,
  DialogContentText,
} from "@mui/material";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import { toast } from "react-toastify";
import axios from "axios";
import { connect } from "react-redux";
import {
  setDialedNumberInc,
  getAvailableAgentList,
} from "../../Redux/Actions/actions";
import { ArrowCounterClockwise, PhoneOutgoing } from "@phosphor-icons/react";
import { PiPhoneTransferFill } from "react-icons/pi";
import { TiWarningOutline } from "react-icons/ti";
import { Hourglass } from "react-loader-spinner";
import { FunnelSimple } from "@phosphor-icons/react";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
  MissedCallTableHead,
} from "../../CustomComponent/TableCompoent";
import { toaststyle } from "../../Utils/toaststyle";
import { MdClose, MdDeleteForever } from "react-icons/md";

const mapStateToProps = (state) => {
  return {
    skillset: state.data.skillset,
    showingStatusVoice: state.contactListData.showingStatusVoice,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};

const MissedCall = (props) => {
  let loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return new Date(todate) >= new Date(fromdate);
  };

  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");
  const [getTransferDate, setgetTransferDate] = useState();
  const [showfilter, setshowfilter] = useState(false);
  const [status, setstatus] = useState("");
  const [missedCallList, setmissedCallList] = useState([]);

  const [agentlist, setAgentlist] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [spinner, setspinner] = useState(false);
  const [openDialog, setopenDialog] = useState(false);
  const [sourceAgents, setsourceAgents] = useState("");
  const [DestinationAgents, setDestinationAgents] = useState("");

  const [selectedCalls, setselectedCalls] = useState();
  const [totalcalls, settotalcalls] = useState(0);

  //  my code
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [selectedRowsByPage, setSelectedRowsByPage] = useState({});
  const [selectAllByPage, setSelectAllByPage] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (event, value) => {
    setPage(value);
    if (loggedInAgent.role == "Supervisor") {
      MissedCallsAPiSupervisor(value);
    } else {
      MissedCallsAPi(value);
    }
  };

  const handleRowSelect = (rowData) => {
    setSelectedRowIds((prevSelectedRowIds) => {
      if (prevSelectedRowIds.includes(rowData.id)) {
        return prevSelectedRowIds.filter((id) => id !== rowData.id);
      } else {
        return [...prevSelectedRowIds, rowData.id];
      }
    });

    setSelectedRowsByPage((prev) => {
      const pageSelectedRows = prev[page] || [];
      if (pageSelectedRows.includes(rowData.id)) {
        return {
          ...prev,
          [page]: pageSelectedRows.filter((id) => id !== rowData.id),
        };
      } else {
        return {
          ...prev,
          [page]: [...pageSelectedRows, rowData.id],
        };
      }
    });
  };

  const handleSelectAll = () => {
    const pageRows = missedCallList.map((row) => row.id);
    if (selectAll) {
      setSelectedRowsByPage((prev) => ({
        ...prev,
        [page]: [],
      }));
    } else {
      setSelectedRowsByPage((prev) => ({
        ...prev,
        [page]: pageRows,
      }));
    }

    setSelectAllByPage((prev) => ({
      ...prev,
      [page]: !selectAll,
    }));
    setSelectAll(!selectAll);
    setSelectedRowIds([]);
  };

  const handleDelete = async (rowData) => {
    const selectedRowsForPage = selectedRowsByPage[page] || [];

    // if (selectedRowsForPage.includes(rowData.id)) {

    let data = {
      type: "callback",
      contactid: rowData.id,
    };

    await axios
      .post(BaseUrl + "/contact/deletesalesservice", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status === true) {
          // Refresh the service report after deletion
          MissedCallsAPiSupervisor();
          setSelectedRowIds([]);
          setSelectedRowsByPage({});
          toast.success(res.data.message);
        } else {
          setSelectedRowIds([]);
          setSelectedRowsByPage({});
          toast.warn(res.data.message);
        }
      })
      .catch((error) => {
        toast.warn(res.data.message);
        console.error("Error during deletion:", error);
      });
    // }
    // else {
    //   console.log("Row not selected, deletion not performed.");
    // }
  };

  const handleDeleteAll = async () => {
    const pageRows = missedCallList.map((row) => row.id);
    // if (selectAll) {
    let data = {
      type: "callback",
      // contactid: selectedRowIds?selectedRowIds:pageRows,
      contactid: selectAll ? pageRows : selectedRowIds,
    };

    await axios
      .post(BaseUrl + "/contact/deletebulksalesservice", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status === true) {
          setSelectAll(false);
          MissedCallsAPiSupervisor();
          setSelectedRowIds([]);
          setSelectedRowsByPage({});
          setSelectAllByPage({});
          toast.success(res.data.message);
        } else {
          setSelectAll(false);
          setSelectedRowIds([]);
          toast.warn(res.data.message);
        }
      })
      .catch((error) => {
        toast.warn(res.data.message);
        setSelectAll(false);
        setSelectedRowIds([]);
        console.error("Error during deletion:", error);
      });
    // }
    // else {
    //   console.log("Row not selected, deletion not performed.");
    // }
  };

  const MissedCallsAPi = (value) => {
    if (!value) {
      setspinner(true);
    }
    axios
      .post(
        BaseUrl + "/contact/listCampaignDetails",
        {
          from_date: fromdate,
          to_date: todate,
          agent_id: loggedInAgent.agent_id,
          limit: 10,
          offset: value != null ? (value === 1 ? 0 : (value - 1) * 10) : 0,
          type: status,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setspinner(true);
        if (res.data.status) {
          setmissedCallList(res.data.data);
          settotalcalls(res.data.count);
          setPagination(res.data.count);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        } else {
          setmissedCallList([]);
          settotalcalls(0);
          setPagination(0);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setspinner(false);
        }, 1500);
      });
  };
  const MissedCallsAPiSupervisor = (value) => {
    if (!value) {
      setspinner(true);
    }
    axios
      .post(
        BaseUrl + "/contact/listCampaignDetailssupervisor",
        {
          from_date: fromdate,
          to_date: todate,
          agent_id: "",
          limit: 10,
          offset: value != null ? (value === 1 ? 0 : (value - 1) * 10) : 0,
          type: status,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setspinner(true);
        if (res.data.status) {
          setmissedCallList(res.data.data);
          settotalcalls(res.data.count);
          setPagination(res.data.count);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        } else {
          setmissedCallList([]);
          settotalcalls(0);
          setPagination(0);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setspinner(false);
        }, 1500);
      });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (loggedInAgent.role == "Supervisor") {
        MissedCallsAPiSupervisor("noSpinner");
      } else {
        MissedCallsAPi("noSpinner");
      }
    }, 60000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (loggedInAgent.role == "Supervisor") {
      MissedCallsAPiSupervisor();
    } else {
      MissedCallsAPi();
    }
  }, []);

  const handleCloseDialogBox = () => {
    setopenDialog(false);
  };

  const handleChangeCount = (event) => {
    setselectedCalls(event.target.value);
  };

  const transfer = async () => {
    if (sourceAgents == DestinationAgents) {
      setErrorMessage("Source and Destination agents cannot be the same.");
      return;
    }

    setErrorMessage("");

    await axios
      .post(
        BaseUrl + "/contact/updatecampaignDetailsagent",
        {
          source_id: sourceAgents,
          destination_id: DestinationAgents,
          count: selectedCalls,
          date: getTransferDate,
          type: "Abandoned",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setopenDialog(false);
          MissedCallsAPiSupervisor();
          toast.success(res.data.message, toaststyle);
        } else {
          setopenDialog(false);
          MissedCallsAPiSupervisor();
          toast.warn(res.data.message, toaststyle);
        }
      })
      .catch((err) => {
        setShow(true);
      });
  };

  const makeCall = (calledNo, value2) => {
    let number = `9${calledNo}`;
    if (props.showingStatusVoice == "Ready") {
      let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
      let avcurlid = localStorage.getItem("AvcUrl");
      props.setDialedNumberInc(number);
      localStorage.setItem("callDirectionType", "MC_Outbound");
      localStorage.setItem("dailedNumber", number);
      localStorage.setItem("ClickToCall", "true");
      localStorage.setItem("clickToCallCallerID", value2);
      axios
        .post(
          avcurlid +
            `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${
              localStorage.getItem("TenantId") ==
              "788205e1-6116-4c09-904a-5b641d09de0f"
                ? VoiceDomainNamePure
                : VoiceDomainName
            }/sip:${number}@${
              localStorage.getItem("TenantId") ==
              "788205e1-6116-4c09-904a-5b641d09de0f"
                ? VoiceDomainNamePure
                : VoiceDomainName
            }`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            localStorage.setItem("DCC_CALL", "true");
          } else {
            toast.warn(res.data.status, toaststyle);
          }
        })
        .catch((err) => {
          console.log("makeCall", err.code == " ERR_BAD_REQUEST");
          if (err.code == "ERR_BAD_REQUEST") {
            toast.error("Please change status to Ready", toaststyle);
          }
        });
    } else {
      toast.error("Please change status to Ready", toaststyle);
    }
  };

  const convertDateTime = (date) => {
    if (!date) return;
    return new Date(date).toISOString().replace("T", " ").substring(0, 19);
  };

  return (
    // Missed Call start here
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Missed Call
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >
              {/*  Transfer Call btn  */}
              {loggedInAgent.role == "Supervisor" && (
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setopenDialog(true);
                    props.getAvailableAgentList();
                    agentListdropdown();
                  }}
                >
                  <PiPhoneTransferFill className="me-2" />
                  Transfer Call
                </Button>
              )}

              {/* Refresh btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  if (loggedInAgent.role == "Supervisor") {
                    MissedCallsAPiSupervisor();
                  } else {
                    MissedCallsAPi();
                  }
                  setspinner("rotate 1s infinite");
                }}
              >
                <ArrowCounterClockwise
                  style={{ animation: spinner }}
                  className="me-2"
                />
                Refresh
              </Button>
              {/* Filter btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  setshowfilter(true);
                }}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                {loggedInAgent.role == "Supervisor" ? (
                  <>
                    <MissedCallTableHead>
                      <StyledTableRow>
                        {!missedCallList.length ? (
                          ""
                        ) : (
                          <StyledTableCell style={{ minWidth: "50px" }}>
                            {/* "Select All" checkbox */}
                            <div className="d-flex">
                              <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAll}
                              />
                              {selectAll || selectedRowIds.length ? (
                                <MdDeleteForever
                                  color="error"
                                  onClick={handleDeleteAll}
                                  className="mx-1"
                                  fontSize="medium"
                                  style={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </StyledTableCell>
                        )}

                        {[
                          "Agent",
                          "Phone Number",
                          "SkillSet",
                          "CreatedDate",
                          "OriginatedStamp",
                          "Retry Count",
                          "Call Status",
                          "Action",
                        ].map((headers) => (
                          <StyledTableCell style={{ minWidth: "150px" }}>
                            {headers}
                          </StyledTableCell>
                        ))}
                      </StyledTableRow>
                    </MissedCallTableHead>
                    <StyledTableBody>
                      {spinner ? (
                        <Stack
                          sx={{ position: "absolute", top: "50%", left: "50%" }}
                        >
                          <Hourglass
                            visible={true}
                            height="30"
                            width="30"
                            ariaLabel="hourglass-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            colors={["#2268a0", "#72a1ed"]}
                          />
                        </Stack>
                      ) : missedCallList.length > 0 ? (
                        missedCallList.map((item) => {
                          return (
                            <StyledTableRow hover role="checkbox" tabIndex={-1}>
                              <StyledTableCell2>
                                {/* Individual row checkbox */}
                                <input
                                  type="checkbox"
                                  checked={(
                                    selectedRowsByPage[page] || []
                                  ).includes(item.id)}
                                  onChange={() => handleRowSelect(item)}
                                />
                              </StyledTableCell2>

                              <StyledTableCell2>
                                {item.agent_id.username}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.Originator}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.SkillSet}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {convertDateTime(item.CreatedDate)}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {convertDateTime(item.OriginatedStamp)}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.callcount ? item.callcount : 0}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.callstatus ? item.callstatus : "NA"}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                <MdDeleteForever
                                  onClick={() => handleDelete(item)}
                                  color="error"
                                  style={{
                                    fontSize: "18px",
                                    cursor: "pointer",
                                  }}
                                />
                              </StyledTableCell2>
                            </StyledTableRow>
                          );
                        })
                      ) : (
                        // Data unavailable start
                        <Stack
                          sx={{
                            position: "absolute",
                            width: "100%",
                            height: "calc(100vh - 14rem)",
                          }}
                          justifyContent="center"
                          alignContent="center"
                        >
                          <Stack
                            className="text-muted"
                            direction="column"
                            justifyContent="center"
                            alignContent="center"
                          >
                            <span className="mx-auto">
                              <img
                                src={Nodata}
                                alt="pic"
                                style={{ width: "11rem", userSelect: "none" }}
                              />
                            </span>
                            <span className="mx-auto">
                              <h6
                                className="text-muted mt-3"
                                style={{ fontSize: "13px" }}
                              >
                                Data unavailable
                              </h6>
                            </span>
                          </Stack>
                        </Stack>
                        // Data unavailable end
                      )}
                    </StyledTableBody>
                  </>
                ) : (
                  <>
                    <StyledTableHead>
                      <StyledTableRow>
                        {[
                          "Action",
                          "Phone Number",
                          "SkillSet",
                          "CreatedDate",
                          "OriginatedStamp",
                          "Retry Count",
                          "Call Status",
                        ].map((headers) => (
                          <StyledTableCell style={{ minWidth: "150px" }}>
                            {headers}
                          </StyledTableCell>
                        ))}
                      </StyledTableRow>
                    </StyledTableHead>
                    {spinner ? (
                      <Stack
                        sx={{ position: "absolute", top: "50%", left: "50%" }}
                      >
                        <Hourglass
                          visible={true}
                          height="30"
                          width="30"
                          ariaLabel="hourglass-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          colors={["#2268a0", "#72a1ed"]}
                        />
                      </Stack>
                    ) : missedCallList.length > 0 ? (
                      missedCallList.map((item) => {
                        return (
                          <StyledTableRow hover role="checkbox" tabIndex={-1}>
                            <StyledTableCell2>
                              <IconButton
                                onClick={() => {
                                  makeCall(item.Originator, item.id);
                                }}
                              >
                                <PhoneOutgoing size={18} weight="bold" />
                              </IconButton>
                            </StyledTableCell2>
                            <StyledTableCell2>
                              {item.Originator}
                            </StyledTableCell2>
                            <StyledTableCell2>{item.SkillSet}</StyledTableCell2>
                            <StyledTableCell2>
                              {convertDateTime(item.CreatedDate)}
                            </StyledTableCell2>
                            <StyledTableCell2>
                              {convertDateTime(item.OriginatedStamp)}
                            </StyledTableCell2>
                            <StyledTableCell2>
                              {item.callcount ? item.callcount : 0}
                            </StyledTableCell2>
                            <StyledTableCell2>
                              {item.callstatus ? item.callstatus : "NA"}
                            </StyledTableCell2>
                          </StyledTableRow>
                        );
                      })
                    ) : (
                      // Data unavailable start
                      <Stack
                        sx={{
                          position: "absolute",
                          width: "100%",
                          height: "calc(100vh - 14rem)",
                        }}
                        justifyContent="center"
                        alignContent="center"
                      >
                        <Stack
                          className="text-muted"
                          direction="column"
                          justifyContent="center"
                          alignContent="center"
                        >
                          <span className="mx-auto">
                            <img
                              src={Nodata}
                              alt="pic"
                              style={{ width: "11rem", userSelect: "none" }}
                            />
                          </span>
                          <span className="mx-auto">
                            <h6
                              className="text-muted mt-3"
                              style={{ fontSize: "13px" }}
                            >
                              Data unavailable
                            </h6>
                          </span>
                        </Stack>
                      </Stack>
                      // Data unavailable end
                    )}
                  </>
                )}
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                {Math.min(page * 10, pagination)} of {pagination} entries
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>

      {/* Filters start here  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setshowfilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form>
              <div className="mb-3 d-flex flex-column text-start">
                <label htmlFor="fromdate" className="form-label">
                  From
                </label>
                <input
                  type="date"
                  className="form-control"
                  id=""
                  aria-describedby="date"
                  value={fromdate}
                  onChange={(e) => setFromdate(e.target.value)}
                  max={defaultValue}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label htmlFor="todate" className="form-label">
                  To
                </label>
                <input
                  type="date"
                  className="form-control"
                  id=""
                  aria-describedby="date"
                  value={todate}
                  onChange={(e) => setTodate(e.target.value)}
                  max={defaultValue}
                />
                {!isToDateValid() && (
                  <span
                    className="text-danger fw-bold"
                    style={{ fontSize: "10px" }}
                  >
                    To Date cannot be less than From Date*
                  </span>
                )}
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label htmlFor="Select" className="form-label">
                  Status
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  onChange={(e) => setstatus(e.target.value)}
                  value={status}
                >
                  <option value="">Select Status</option>
                  <option value="Pending">Pending</option>
                  <option value="Completed">Completed</option>
                  <option value="All">ALL</option>
                </select>
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={() => {
                setshowfilter(false);
              }}
            >
              Close
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={() => {
                if (isToDateValid()) {
                  if (loggedInAgent.role == "Supervisor") {
                    MissedCallsAPiSupervisor();
                  } else {
                    MissedCallsAPi();
                  }
                  setPage(1);
                  setshowfilter(false);
                }
              }}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters end here  */}
      {/* transfer call start here  */}
      <Dialog
        open={openDialog}
        keepMounted
        onClose={handleCloseDialogBox}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          variant="subtitle2"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#0b3363",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          }}
        >
          Transfer Call
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Box className="mt-3">
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <label for="cars" className="form-label">
                    Source Agent
                  </label>
                  <select
                    className="form-select"
                    placeholder="Select Source Agent"
                    onChange={(e) => {
                      setsourceAgents(e.target.value);
                    }}
                    defaultValue=""
                  >
                    <option value="" disabled>
                      Select Agent
                    </option>
                    {props.DropDownAgentList.length > 0 ? (
                      props.DropDownAgentList.map((Agent) => (
                        <option value={Agent.id} key={Agent.id}>
                          {Agent.username}
                        </option>
                      ))
                    ) : (
                      <option value="">No Data</option>
                    )}
                  </select>
                  {/* Validation Error Message */}
                  {sourceAgents === DestinationAgents && sourceAgents && (
                    <p style={{ color: "red", fontSize: "0.7rem" }}>
                      Source Agent and Destination Agent cannot be the same.
                    </p>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <label for="cars" className="form-label">
                    Destination Agent{" "}
                  </label>
                  <select
                    className="form-select"
                    onChange={(e) => {
                      setDestinationAgents(e.target.value);
                    }}
                    defaultValue=""
                  >
                    <option value="" disabled>
                      Select Agent
                    </option>
                    {props.DropDownAgentList.length > 0 ? (
                      props.DropDownAgentList.map((Agent) => (
                        <option value={Agent.id} key={Agent.id}>
                          {Agent.username}
                        </option>
                      ))
                    ) : (
                      <option>{"No Data"}</option>
                    )}
                  </select>
                </Grid>
                <Grid item xs={6}>
                  <label for="cars" className="form-label">
                    Number{" "}
                  </label>
                  <select onChange={handleChangeCount} className="form-select">
                    {Array.from({ length: totalcalls }, (_, index) => (
                      <option value={index + 1} key={index}>
                        {index + 1}
                      </option>
                    ))}
                  </select>
                </Grid>
              </Grid>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialogBox}
            variant="outlined"
            color="error"
            size="small"
            sx={{ textTransform: "capitalize" }}
          >
            Close
          </Button>
          <Button
            variant="contained"
            onClick={transfer}
            disableElevation
            size="small"
            sx={{ textTransform: "capitalize !important" }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {/* transfer call end here  */}
    </StyledPaper>
    // Missed Call end here
  );
};

export default connect(mapStateToProps, {
  setDialedNumberInc,
  getAvailableAgentList,
})(MissedCall);
